import type { BackendTypes } from '@tf/api';

export type ExperienceCellKind = 'boolean' | 'score' | 'money' | 'enum' | 'text' | 'number';

export const getExperienceCellKind = (
	field: Pick<BackendTypes.FieldDefinition, 'type' | 'ref'>,
	isScoreScale?: boolean,
): ExperienceCellKind => {
	if (field.type === 'boolean') {
		return 'boolean';
	}
	if (isScoreScale) {
		return 'score';
	}
	if (field.type === 'money') {
		return 'money';
	}
	if (field.type === 'enum' && field.ref) {
		return 'enum';
	}
	if (field.type === 'text') {
		return 'text';
	}
	return 'number';
};
